<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0 ">
    <van-cell-group>
      <van-cell title="所属省市" :value="row.county?row.province+'/'+row.city+'/'+row.county:''"/>
      <van-cell title="类型" :value="row.kaojitype"/>
      <van-cell title="单位" :value="row.danwei"/>
      <van-cell title="授权编号" :value="row.kaojiregist_code"/>
      <van-cell title="场地面积" :value="row.chandimianji"/>
      <van-cell title="拟注册运动员人数" :value="row.yundongyuanrenshu"/>
      <van-cell title="单位地址" :value="row.county?row.province+'/'+row.city+'/'+row.county:''"/>
      <van-cell title="详细地址" :value="row.address"/>
      <van-cell title="场地照片">
        <a :href="item.url" v-for="item in row.changdipic" style="margin-left: 10px"><img style="max-height: 50px;" :src="item.url" /> </a>
      </van-cell>
      <van-cell title="执照">
        <a :href="item.url" v-for="item in row.zhizhaopic" style="margin-left: 10px"><img style="max-height: 50px;" :src="item.url" /></a>
      </van-cell>
    </van-cell-group>
    <van-divider>负责人信息</van-divider>
    <van-cell-group>
      <van-cell title="负责人姓名" :value="row.nickname"/>
      <van-cell title="负责人身份证号" :value="row.certificatenumber"/>
      <van-cell title="负责人邮箱" :value="row.email"/>
      <van-cell title="负责人手机" :value="row.phone"/>
      <!--    <van-cell title="负责人QQ" :value="row.qq"/>-->
      <!--    <van-cell title="负责人微信" :value="row.weixin"/>-->
    </van-cell-group>
    <van-divider>审核信息</van-divider>
    <van-cell title="现场验收图片">
      <a :href="item.url" v-for="item in row.kaoji_yanshoufile" style="margin-left: 10px"><img style="max-height: 50px;" :src="item.url"/></a>
    </van-cell>
    <van-cell title="备案审核">
      <div v-if="row.kaojiregist_status==0">未提交</div>
      <div v-else-if="row.kaojiregist_status==1">待审核</div>
      <div v-else-if="row.kaojiregist_status==2">审核通过</div>
      <div v-else-if="row.kaojiregist_status==3">审核失败</div>
      <div v-else-if="row.kaojiregist_status==4">预审核div</div>
    </van-cell>
    <van-cell title="加盟类型">
      <div v-if="row.kaoji_jiameng_type==0">未知</div>
      <div v-else-if="row.kaoji_jiameng_type==1">老政策</div>
      <div v-else-if="row.kaoji_jiameng_type==2">0元</div>
      <div v-else-if="row.kaoji_jiameng_type==3">9800元</div>
      <div v-else-if="row.kaoji_jiameng_type==4">12万元</div>
      <div v-else-if="row.kaoji_jiameng_type==5">13.5万元</div>
    </van-cell>
    <van-cell title="拒绝审核理由" :value="row.kaojiregist_status_des"/>
    <van-cell title="器材购买金额" :value="row.kaoji_buyprice"/>
    <van-cell title="到账情况备注" :value="row.kaoji_buynote"/>
  </div>
</template>

<style scoped="">
</style>
<script>
import {
  Cell, CellGroup, Field, RadioGroup, Radio, DatetimePicker, Picker, NoticeBar, Button, Dialog, Uploader
} from 'vant';

export default {
  name: 'WyhExameCenterDetail',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Uploader.name]: Uploader,
  },
  data: function () {
    return {
      row: {
        changdipic:[],
        zhizhaopic:[],
        kaoji_yanshoufile:[],
      },
      formData: {
        'id': this.$route.query.id,
      },
      showTime: false,
      timeField: '',
      showStation: false,
      stationField: '',
      loadding: false,
    }
  },
  mounted: function () {
    let that = this;
    document.title = "考级中心考级点详情";
    this.$api.get('/wyhadminapi/examecenter/centerDetail', {
      'id': that.$route.query.id
    }, r => {
      this.row = r.data;
      console.log(this.row)
    });

  },

  methods: {
    save: function () {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '您确定信息准确无误吗?提交后不得修改!'
      }).then(() => {
        // on confirm
        that.$api.post('/api/sai/confirmzhixuceaction', this.formData, r => {
          that.$router.push({'name': 'saiConfirm', 'query': {'id': that.row.id}});
        }, r => {
          that.$toast.fail(r.msg);
        });
      }).catch(() => {
        // on cancel
      });


    },
    edit: function () {
      let that = this;
      this.$router.push({
        'name': 'saiConfirmQr1',
        'query': {'id': that.row.id}
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// ExameCenterDetail.vue?0ff922f8